import { siteApiSlice } from "../../../../app/siteApiSlice";
import { AdminReportsResponse, AdminReportsRowBase } from "../adminReportsApiSlice";

export interface AverageMonthlyScoresModel {
	districtId?: number;
	schoolId?: number;
	schoolYear?: number;
	scoreCategoryId?: number;
	genreId?: number;
	draftStatus?: number;
}

export interface AverageMonthlyScoresRow extends AdminReportsRowBase {
	aug: number;
	sep: number;
	oct: number;
	nov: number;
	dec: number;
	jan: number;
	feb: number;
	mar: number;
	apr: number;
	may: number;
	jun: number;
	jul: number;
	average: number;
}

export interface AverageMonthlyScoresReponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<AverageMonthlyScoresRow>;
}

export const adminProgressReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		averageMonthlyScores: build.query<AverageMonthlyScoresReponse, AverageMonthlyScoresModel>({
			query: (model) => {
				return {
					url: `/AdminReports/AverageMonthlyScoresAjaxHandler`,
					params: model,
				};
			},
		}),
	}),
});

export const { useAverageMonthlyScoresQuery, useLazyAverageMonthlyScoresQuery } =
	adminProgressReportApiSlice;
